import classNames from "classnames";
import React from "react";
import {
  AdjustmentsVerticalIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from "@heroicons/react/24/outline";
import CiroButton, { CiroButtonStyleEnum } from "../../shared/CiroButton";

interface IAutopilotSessionToggleDetailsButton {
  showFilters: boolean;
  setShowFilters: (show: boolean) => void;
}

const AutopilotSessionToggleDetailsButton = ({
  showFilters,
  setShowFilters,
}: IAutopilotSessionToggleDetailsButton) => {
  const handleClick = () => setShowFilters(!showFilters);
  const buttonLabel = showFilters
    ? "Hide search details"
    : "Show search details";
  const buttonColor = showFilters ? "text-gray-700" : "text-gray-500";

  const iconClasses = classNames("h-4", "w-4", buttonColor);
  const chevronClasses = classNames(
    "h-3.5",
    "w-3.5",
    "transition-transform",
    "duration-200",
    buttonColor,
  );
  const commonButtonProps = {
    style: CiroButtonStyleEnum.UNSTYLED,
    onClick: handleClick,
  };

  const ChevronIcon = showFilters ? ChevronUpIcon : ChevronDownIcon;
  const buttonStyleClasses = classNames(
    "rounded-lg",
    "transition-all",
    "duration-200",
    "hover:bg-gray-200",
  );

  return (
    <>
      {/* Small screen button (icon only with tooltip) - hidden on xl screens */}
      <div className={classNames("xl:hidden")}>
        <CiroButton
          {...commonButtonProps}
          analyticsField="Toggle search details (Small)"
          tooltip={buttonLabel}
          customClassName={classNames(buttonStyleClasses, "px-2")}
        >
          <div
            className={classNames("flex", "items-center", "py-4", buttonColor)}
          >
            <AdjustmentsVerticalIcon className={iconClasses} />
            <ChevronIcon className={classNames(chevronClasses, "ml-1")} />
          </div>
        </CiroButton>
      </div>

      {/* Large screen button (icon + text) - hidden on smaller screens */}
      <div className={classNames("hidden", "xl:block")}>
        <CiroButton
          {...commonButtonProps}
          analyticsField="Toggle search details (Large)"
          customClassName={classNames(buttonStyleClasses, "px-3")}
        >
          <div
            className={classNames(
              "flex",
              "items-center",
              "gap-2",
              "py-3",
              buttonColor,
            )}
          >
            <AdjustmentsVerticalIcon className={iconClasses} />
            <span className={classNames("text-sm", "font-medium", buttonColor)}>
              {buttonLabel}
            </span>
            <ChevronIcon className={chevronClasses} />
          </div>
        </CiroButton>
      </div>
    </>
  );
};

export default AutopilotSessionToggleDetailsButton;
